/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Auth_Shell_Pick_TitleInputs */

const en_auth_shell_pick_title = /** @type {(inputs: Auth_Shell_Pick_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You picked ${i?.time}`)
};

const pl_auth_shell_pick_title = /** @type {(inputs: Auth_Shell_Pick_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wybrałeś ${i?.time}`)
};

/**
* | output |
* | --- |
* | "You picked {time}" |
*
* @param {Auth_Shell_Pick_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_shell_pick_title = /** @type {((inputs: Auth_Shell_Pick_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Shell_Pick_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_shell_pick_title(inputs)
	return en_auth_shell_pick_title(inputs)
});